import { formatMoney } from "@/lib/money"

interface Props {
  actual: number
  /** Null = no target to compare with. Shown as a plain hint, never a guessed target. */
  target: number | null
  currency: string
  /** Table rows show only the bar and percent; tiles also name the target. */
  compact?: boolean
  /** The plan window, printed after the target: "Jul 1 – Dec 31, 2026". */
  period?: string
  /** Shown in place of the bar when there is no target. */
  emptyText?: string
  /** Off when the percent is already shown big, as on the Plan progress tile. */
  showPct?: boolean
}

export default function TargetBar({ actual, target, currency, compact = false, period, emptyText = "No published plan", showPct = true }: Props) {
  if (target == null || target <= 0) return <span className="text-xs text-muted-foreground">{emptyText}</span>

  const pct = Math.round((actual / target) * 100)
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <div className="h-2 w-full min-w-20 overflow-hidden rounded-full bg-muted">
          <div className="h-full rounded-full bg-primary/40" style={{ width: `${Math.min(pct, 100)}%` }} />
        </div>
        {showPct && <span className="text-xs font-medium tabular-nums">{pct}%</span>}
      </div>
      {!compact && <div className="text-xs">of plan target {formatMoney(target, currency)}{period ? ` (${period})` : ""}</div>}
    </div>
  )
}
